import { render, staticRenderFns } from "./CourseImageHeader.vue?vue&type=template&id=4937848e&scoped=true"
import script from "./CourseImageHeader.vue?vue&type=script&lang=js"
export * from "./CourseImageHeader.vue?vue&type=script&lang=js"
import style0 from "./CourseImageHeader.vue?vue&type=style&index=0&id=4937848e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937848e",
  null
  
)

export default component.exports